// extracted by mini-css-extract-plugin
module.exports = {"Item":"context-menu-item_Item__cMlIk"};